import { useEffect, useRef, useState } from 'react';

const VIDEO_MP4 =
  import.meta.env.VITE_HOME_HERO_VIDEO || '/media/home-hero.mp4';
const VIDEO_WEBM = import.meta.env.VITE_HOME_HERO_VIDEO_WEBM || '';
const POSTER = import.meta.env.VITE_HOME_HERO_POSTER || '';

function usePrefersReducedMotion() {
  const [reduced, setReduced] = useState(false);
  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    const sync = () => setReduced(mq.matches);
    sync();
    mq.addEventListener('change', sync);
    return () => mq.removeEventListener('change', sync);
  }, []);
  return reduced;
}

/**
 * Зацикленное видео только на главной (`/:translation/home`).
 * Файл: front/public/media/home-hero.mp4
 */
export default function BfHomeVideoBackdrop() {
  const videoRef = useRef(null);
  const [ready, setReady] = useState(false);
  const [failed, setFailed] = useState(false);
  const reducedMotion = usePrefersReducedMotion();

  useEffect(
    () => () => {
      const video = videoRef.current;
      if (!video) return;
      video.pause();
      video.removeAttribute('src');
      video.load();
    },
    []
  );

  useEffect(() => {
    if (reducedMotion || failed) return undefined;
    const video = videoRef.current;
    if (!video) return undefined;
    const play = () => {
      video.play().catch(() => {
        /* autoplay иногда блокируется — не считаем это фатальной ошибкой */
      });
    };
    if (video.readyState >= 2) play();
    else video.addEventListener('canplay', play, { once: true });
    return () => video.removeEventListener('canplay', play);
  }, [reducedMotion, failed]);

  const handleError = () => {
    const video = videoRef.current;
    if (!video?.error) return;
    setFailed(true);
  };

  const showVideo = !reducedMotion && !failed;

  return (
    <div
      className={`bf-home-cinema${ready ? ' bf-home-cinema--ready' : ''}${failed || reducedMotion ? ' bf-home-cinema--fallback' : ''}`}
      aria-hidden="true"
    >
      <div className="bf-home-cinema__ambient" />
      {showVideo && (
        <video
          ref={videoRef}
          className="bf-home-cinema__video"
          src={VIDEO_MP4}
          poster={POSTER || undefined}
          muted
          loop
          playsInline
          autoPlay
          preload="auto"
          onLoadedData={() => setReady(true)}
          onCanPlay={() => setReady(true)}
          onError={handleError}
        >
          {VIDEO_WEBM ? <source src={VIDEO_WEBM} type="video/webm" /> : null}
        </video>
      )}
      <div className="bf-home-cinema__shade" />
      <div className="bf-home-cinema__grain" />
    </div>
  );
}
